import { NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';

export interface IImageDialogData {
  imageUrl: string;
  cancelButtonText?: string;
}

@Component({
  imports: [MatButton, MatDialogActions, MatDialogContent, NgIf],
  selector: 'app-image-dialog',
  template: `
    <div mat-dialog-content><img [src]="data.imageUrl" style="width:100%; height:auto;" /></div>
    <div mat-dialog-actions align="end">
      <button *ngIf="data.cancelButtonText" matButton="tonal" (click)="onDismiss()">{{ data.cancelButtonText }}</button>
    </div>
  `,
})
export class ImageDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IImageDialogData,
  ) {}

  public onDismiss(): void {
    this.dialogRef.close(false);
  }
}
